import React, { useState, useEffect } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faSquare, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faCheckSquare, faCreditCard, faUser, faMapMarkerAlt, faMoneyCheck, faMoneyCheckAlt, faUniversity, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faCcAmex, faCcDiscover, faCcJcb, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { getPaymentTypes } from '../../API';
import { usStates } from '../../Helper';

function PaymentInfo(props) {
    const [paymentTypes, setPaymentTypes] = useState([]);

    useEffect(() => {
        fetchPaymentTypes();
    }, [])

    const fetchPaymentTypes = async () => {
        setPaymentTypes(await getPaymentTypes());
    };

    let paymentFormJSX = null;
    switch (props.paymentInfo.sslTransactionType) {
        case 'ccsale':
            paymentFormJSX = (
                <div>
                    <div className="accepted-cards">
                        <div title="American Express">
                            <FontAwesomeIcon icon={faCcAmex} />
                        </div>
                        <div title="Discover">
                            <FontAwesomeIcon icon={faCcDiscover} />
                        </div>
                        <div title="JCB">
                            <FontAwesomeIcon icon={faCcJcb} />
                        </div>

                        <div title="Visa">
                            <FontAwesomeIcon icon={faCcVisa} />
                        </div>
                    </div>
                    <div className="surcharge-disclaimer">
                        All credit card payments must pay an additional 2.5% processing fee.
                    </div>
                    <div className="input-section">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faCreditCard} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Card Number" name="sslCardNumber" value={props.paymentInfo.sslCardNumber || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faCreditCard} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="CVC" name="sslCvv2Cvc2" value={props.paymentInfo.sslCvv2Cvc2 || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                    </div>
                    <div className="input-section">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="First Name" name="sslFirstName" value={props.paymentInfo.sslFirstName || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Last Name" name="sslLastName" value={props.paymentInfo.sslLastName || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                    </div>
                    <div className="input-section">
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faCalendarAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input type="select" placeholder="Expiration Month" name="sslExpMonth" value={props.paymentInfo.sslExpMonth || '01'} onChange={props.updatePaymentInfo}>
                                <option value="01">January</option>
                                <option value="02">February</option>
                                <option value="03">March</option>
                                <option value="04">April</option>
                                <option value="05">May</option>
                                <option value="06">June</option>
                                <option value="07">July</option>
                                <option value="08">August</option>
                                <option value="09">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </Input>
                            <div className="tooltip-target tooltip-top">
                                Expiration Month
                            </div>
                        </InputGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faCalendarAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Expiration Year" name="sslExpYear" value={props.paymentInfo.sslExpYear || ''} onChange={props.updatePaymentInfo} />
                            <div className="tooltip-target tooltip-top">
                                Expiration Year
                            </div>
                        </InputGroup>
                    </div>
                    <div className="input-section">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Address" name="sslAvsAddress" value={props.paymentInfo.sslAvsAddress || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="City" name="sslCity" value={props.paymentInfo.sslCity || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input type="select" name="sslState" value={props.paymentInfo.sslState} onChange={props.updatePaymentInfo}>
                                {usStates.map(s => (<option key={s.abbreviation} value={s.abbreviation}>{s.name}</option>))}
                            </Input>
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Zip Code" name="sslAvsZip" value={props.paymentInfo.sslAvsZip || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                    </div>
                </div>
            );
            break;
        case 'ecspurchase':
            paymentFormJSX = (
                <div>
                    <div className="surcharge-disclaimer">
                        All ACH payments must pay an additional $2.5 processing fee.
                    </div>
                    <div className="input-section">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faUniversity} /></InputGroupText>
                            </InputGroupAddon>
                            <Input type="select" placeholder="Bank Account Type" name="sslBankAccountType" value={props.paymentInfo.sslBankAccountType || 1} onChange={props.updatePaymentInfo}>
                                <option value={1}>Business</option>
                                <option value={0}>Personal</option>
                            </Input>
                        </InputGroup>
                        {props.paymentInfo.sslBankAccountType == 1 ?
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><FontAwesomeIcon icon={faBuilding} /></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Company Name" name="sslCompany" value={props.paymentInfo.sslCompany || ''} onChange={props.updatePaymentInfo} />
                            </InputGroup>
                        : null}
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMoneyCheck} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Account Number" name="sslBankAccountNumber" value={props.paymentInfo.sslBankAccountNumber || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMoneyCheck} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Routing Number" name="sslRoutingNumber" value={props.paymentInfo.sslRoutingNumber || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                    </div>
                    <div className="input-section">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="First Name" name="sslFirstName" value={props.paymentInfo.sslFirstName || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Last Name" name="sslLastName" value={props.paymentInfo.sslLastName || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                    </div>
                    <div className="input-section">
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Address" name="sslAvsAddress" value={props.paymentInfo.sslAvsAddress || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="City" name="sslCity" value={props.paymentInfo.sslCity || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input type="select" name="sslState" value={props.paymentInfo.sslState} onChange={props.updatePaymentInfo}>
                                {usStates.map(s => (<option key={s.abbreviation} value={s.abbreviation}>{s.name}</option>))}
                            </Input>
                        </InputGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Zip Code" name="sslAvsZip" value={props.paymentInfo.sslAvsZip || ''} onChange={props.updatePaymentInfo} />
                        </InputGroup>
                    </div>
                </div>
            );
            break;
        default:
            break;
    }

    console.log(props.options.transactionTypes);
    console.log(paymentTypes);
    return (
        <div className="payment-info">
            <div className="input-section">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText><FontAwesomeIcon icon={faMoneyCheckAlt} /></InputGroupText>
                    </InputGroupAddon>
                    <Input type="select" name="sslTransactionType" value={props.paymentInfo.sslTransactionType} onChange={props.updatePaymentInfo}>
                        <option value="na">Select Payment Type</option>
                        {paymentTypes.filter(pt => props.options.transactionTypes.includes(pt.transactionType)).map(pt => (<option key={pt.paymentTypeID} value={pt.transactionType}>{pt.paymentTypeName}</option>))}
                    </Input>
                </InputGroup>
            </div>
            {paymentFormJSX}
        </div>
    );
}

export default PaymentInfo;